import TagManager from "react-gtm-module";
import { getCookieSetting } from "./Cookie.helper";

export const initGtm = () => {
    console.log("GTM initGtm");
    const cookieSetting = getCookieSetting();
    console.log("GTM initGtm cookieSetting", cookieSetting);
    if (cookieSetting?.analytics) {
        console.log("GTM initGtm enableGtm");
        enableGtm();
    } else {
        console.log("GTM initGtm disableGtm");
        disableGtm();
    }
}

export interface IUserProperties {
    user_type: string;
    user_type_id: number;
    preferred_language: string;
    device_type: string | null;
    device_os: string | null;
    device_os_version: string | null;
}

export const setUserProperties = (properties: IUserProperties) => {
    console.log("GTM setUserProperties", properties);
    TagManager.dataLayer({
        dataLayer: {
            event: "user_properties",
            ...properties
        }
    });
}

export const clearUserProperties = () => {
    console.log("GTM clearUserProperties");
    const properties: IUserProperties = {
        user_type: null,
        user_type_id: null,
        preferred_language: null,
        device_type: null,
        device_os: null,
        device_os_version: null,
    }
    setUserProperties(properties);
}

export interface IEventProperties {
    event: string; // 이벤트 이름 
    category: string | null; // 선택 : 이벤트 분류(그룹 명)
    action: string | null; // 선택 : 이벤트에서 사용자가 수행하는 동작 명
    label: string | null; // 선택 : 이벤트의 세부 설명이나 구분자
    value: number | null; // 선택 : 이벤트 관련 수치 값(금액, 횟수등)
}

export const sendEvent = (properties: IEventProperties) => {
    console.log("GTM sendEvent", properties);
    TagManager.dataLayer({
        dataLayer: properties
    });
}

export const sendPageViewCompleted = (path: string, location: string) => {
    console.log("GTM sendPageViewCompleted", path, location);
    TagManager.dataLayer({
        dataLayer: {
            event: "page_view",
            page_path: path,
            page_location: location,
            page_title: window.document.title
        }
    });
}

export const enableGtm = () => {
    // enable GTM
    console.log("GTM enableGtm");
    TagManager.initialize({ gtmId: process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID ?? "" });
}

export const disableGtm = () => {
    // disable GTM
    console.log("GTM disableGtm");
    TagManager.dataLayer({
        dataLayer: {
            event: "consent_update",
            analytics_storage: "denied"
        }
    })
}

